/// <reference path="./culori.d.ts" />
/**
 * WCAG contrast helpers for the Brand designer's accessibility nudge. Pure; color
 * math stays here (theme-engine owns culori) so UI packages don't depend on it.
 */
import { wcagContrast } from "culori";
import type { Tokens } from "./tokens.js";

const AA_NORMAL = 4.5;

export function contrastRatio(a: string, b: string): number {
  const r = wcagContrast(a, b);
  return Math.round((r ?? 1) * 100) / 100;
}

export interface ContrastCheck {
  readonly label: string;
  readonly ratio: number;
  /** Meets WCAG AA for normal text (≥ 4.5:1). */
  readonly passesAA: boolean;
}

/** The contrast pairs that matter for a Brand: text legibility on the key surfaces. */
export function brandContrastChecks(tokens: Tokens): readonly ContrastCheck[] {
  const pairs: readonly { label: string; fg: string; bg: string }[] = [
    {
      label: "Body text on background",
      fg: tokens.color.foreground,
      bg: tokens.color.background,
    },
    {
      label: "Text on primary buttons",
      fg: tokens.color.primaryForeground,
      bg: tokens.color.primarySolid,
    },
    {
      label: "Text on accent",
      fg: tokens.color.accentForeground,
      bg: tokens.color.accent,
    },
  ];
  return pairs.map(({ label, fg, bg }) => {
    const ratio = contrastRatio(fg, bg);
    return { label, ratio, passesAA: ratio >= AA_NORMAL };
  });
}
